import * as Sentry from '@sentry/browser';

class ApiError extends Error {
  constructor(error, store) {
    super();

    const { data, status } = error.response;


    this.name = 'ApiError';
    this.message = data.error.message || 'API Error';
    this.devMessage = data.error.message || 'API Error';
    this.status = status || 500;
    this.code = status || 500;

    store.commit('global/setAlertError', {
      state: true,
      message: this.message,
    });

    Sentry.configureScope((scope) => {
      scope.setLevel('error');
    });

    Sentry.captureException(error);
  }
}

export default ApiError;
